import React, { FC } from "react";
import styles from "../../../styles/Loader.module.scss"

interface LoaderDivProps {
  loader?: boolean;
}

const LoaderDiv: FC<LoaderDivProps> = ({ loader }) => {
  let loading = loader ? " " + styles.loading : "";
  return (
    <>
      <div className={styles.loaderCont + loading}>
        <div className={styles.loader}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default LoaderDiv;
